import { ReactComponent as TrendingUp } from './trending_up.svg'
import { ReactComponent as TrendingFlat } from './trending_flat.svg'
import { ReactComponent as TrendingDown } from './trending_down.svg'
import { ReactComponent as TableChartIcon } from './updated-table_chart.svg'
import { ReactComponent as Home } from './home.svg'
import { ReactComponent as HomePending } from './home_timer_pending.svg'
import { ReactComponent as HomeClosed } from './home_monitized.svg'
import { ReactComponent as ClosedCancelInput } from './cancel.svg'
import { ReactComponent as ErrorIcon } from './error.svg'
import { ReactComponent as InfoIcon } from './info.svg'
import { ReactComponent as BrandLogo } from './broker-workplace.svg'
import { ReactComponent as BrandLogoLeftNavCollapsed } from './broker-workplace_nav_collapsed.svg'
import { ReactComponent as BrandLogoLeftNavExpanded } from './broker-workplace_nav_expanded.svg'
import { ReactComponent as AIAssistnatIcon } from './ai-assistant.svg'
import { ReactComponent as AIPromptIcon } from './ai-prompt.svg'
import { ReactComponent as AISuggestIcon } from './ai-suggest.svg'

export {
	TrendingUp,
	TrendingFlat,
	TrendingDown,
	TableChartIcon,
	Home,
	HomePending,
	HomeClosed,
	ClosedCancelInput,
	ErrorIcon,
	InfoIcon,
	BrandLogo,
	BrandLogoLeftNavCollapsed,
	BrandLogoLeftNavExpanded,
	AIAssistnatIcon,
	AIPromptIcon,
	AISuggestIcon
}
